<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="账户"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学校名称">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input size="mini" v-model="params.CardNumber" placeholder="请填写卡号" clearable />
        </el-form-item>
        <el-form-item label="学号">
          <el-input size="mini" v-model="params.StudentNumber" placeholder="请填写学号" clearable />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input size="mini" v-model="params.FullName" placeholder="请填写姓名" clearable />
        </el-form-item>
        <!-- <el-form-item label="绑定电话">
          <el-input size="mini" v-model="params.Mobile" type="number" placeholder="请填写电话号码" clearable />
        </el-form-item> -->
        <el-form-item label="家长电话">
          <el-input size="mini" v-model="params.ContactNumber" type="number" placeholder="请输入家长电话" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SchoolName" label="学校名称" min-width="140"/>
        <el-table-column prop="CardNumber" label="卡号" min-width="100"/>
        <el-table-column prop="StudentNumber" label="学号"/>
        <el-table-column prop="FullName" label="姓名"/>
        <el-table-column prop="ContactNumber1" label="电话一" min-width="110"/>
        <el-table-column prop="Call2" label="电话二" min-width="110"/>
        <el-table-column prop="ContactNumber3" label="电话三" min-width="110"/>
        <el-table-column prop="ShortNum" label="学生短号" width="90"/>
        <el-table-column prop="TotalBalance" label="总余额" width="90" align="center"/>
        <el-table-column prop="Balance" label="充值余额" width="90" align="center"/>
        <el-table-column prop="GiveBalance" label="赠送金额" width="90" align="center"/>
        <el-table-column prop="TelAmountLeft" label="当月低消余额" width="100" align="center">
          <template slot-scope="{row}">
            {{row.TelAmountLeft||0}}
          </template>
        </el-table-column>
        <el-table-column prop="TelAmountOutGive" label="当月赠送套餐外余额" width="90" align="center">
          <template slot-scope="{row}">
            {{row.TelAmountOutGive||0}}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.Status==0">无效</el-tag>
            <el-tag v-else-if="row.Status==1" type="success">有效</el-tag>
            <el-tag v-else type="danger">挂失</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list,exportDialog },
  data() {
    return {
      // api: require("@/api/ed/term").default,
      api: require("@/api/consume/account").default,
      schoolApi: require("@/api/st/school").default,
      params: {
        SchoolId: null,
        StudentNumber: "",
        // IdNumber: "",
        CardNumber: "",
        FullName: "",
        // Mobile: "",
        ContactNumber: "",
      },
      schoolList: [],
    };
  },
  beforeMount() {
    this.schoolApi.list({ Status: 1 }).then(res => {
      if(res.Code == 0) {
        this.schoolList = res.Data;
        // if(res.Data.length>0) {
        //   this.params.SchoolId = res.Data[0].SchoolId;
        // }
      }
    })
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      // this.api.export(this.$commonJs.obj.removeNullKey(this.params));
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
  },
};
</script>